export default __webpack_public_path__ + "static/media/downloadappstore.ecd8c6ad.png";